import Cookies from 'js-cookie';

export const setTokenCookies = (accessToken?: string, refreshToken?: string) => {
  const options = { expires: 1 }; // 7 days

  if (accessToken) {
    Cookies.set('access_token', accessToken, options);
  }
  if (refreshToken) {
    Cookies.set('refresh_token', refreshToken, { expires: 2 });
  }

  Cookies.set('is_logged_in', 'true', options);
};

export const updateAccessTokenCookie = (accessToken: string) => {
  Cookies.set('access_token', accessToken, { expires: 15 / 1440 }); // 15 minutes
};

export const getAccessToken = () => Cookies.get('access_token');
export const getRefreshToken = () => Cookies.get('refresh_token');

export const getIsLoggedIn = () => Cookies.get('is_logged_in') === 'true';

export const removeTokenCookies = () => {
  Cookies.remove('access_token');
  Cookies.remove('refresh_token');
  Cookies.remove('is_logged_in');

  return true;
};
